// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"2609f4b1fa8072b19ea8","303":"3438b730a5779fffe946","495":"26eeb1a6b9c08b209472"}[chunkId] + ".js";
};